import { getReportFooter, getReportHeader } from "@/reports/ReportUtil";
import { styles } from "@/reports/reportStyles";
import useNotesData from "@/composables/notesData";
import { clone } from "@/util/clone";

let sortedData;

function setNotesDocDefinition(structure) {
  const InspectionNotes = [];
  InspectionNotes.push(getInspectionNotesHeader());
  getInspectionNotesDetails(InspectionNotes, structure);

  const SubstructureNotes = [];
  SubstructureNotes.push(getSubstructureNotesHeader());
  getSubstructureNotesDetails(SubstructureNotes, structure);

  let docDefinition = {
    header: function () {
      return getReportHeader("Notes Page", structure);
    },
    footer: function (currentPage, pageCount) {
      return getReportFooter(currentPage, pageCount);
    },
    pageMargins: [20, 70, 20, 50],
    content: [
      { text: "", pageHeaderText: "Notes Page" },
      {
        table: {
          headerRows: 0,
          widths: ["100%"],
          body: [
            [
              {
                text: "Structure Inspection Notes",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [0, 10, 0, 10],
      },
      {
        table: {
          headerRows: 1,
          widths: ["30%", "70%"],
          body: InspectionNotes,
          margin: [50, 50, 50, 50],
        },
      },
      {
        table: {
          headerRows: 0,
          widths: ["100%"],
          body: [
            [
              {
                text: "Structure Unit Inspection Notes",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [0, 10, 0, 10],
      },
      {
        table: {
          headerRows: 1,
          widths: ["15%", "15%", "70%"],
          body: SubstructureNotes,
          margin: [0, 10, 0, 0],
        },
      },
    ],
    styles: styles,
    defaultStyle: {
      fontSize: 10,
    },
  };
  return docDefinition;
}

function getInspectionNotesHeader() {
  return [
    {
      text: "IN.01\n Note Type",
      style: ["tableHeader"],
    },
    {
      text: "IN.02\n Note",
      style: ["tableHeader"],
    },
  ];
}

function getSubstructureNotesHeader() {
  return [
    {
      text: "IN.03\nStructure\nUnit",
      style: ["tableHeader"],
    },
    {
      text: "IN.04\nNote\nType",
      style: ["tableHeader"],
    },
    {
      text: "IN.05\nNote",
      style: ["tableHeader"],
    },
  ];
}

function sortDataBy(data) {
  sortedData = data?.sort(function (a, b) {
    return a?.commentType - b?.commentType;
  });
}

function getInspectionNotesDetails(InspectionNotes, structure) {
  const { noteTypeIN01 } = useNotesData();

  sortDataBy(clone(structure?.inspectionComments));

  for (const detail of sortedData ?? []) {
    InspectionNotes.push(
      [noteTypeIN01(detail?.commentType), detail?.notes].map((d) => {
        return {
          text: d,
          alignment: "left",
        };
      })
    );
  }
}

function getSubstructureNotesDetails(InspectionNotes, structure) {
  const { substuctureUnitIN03, noteTypeIN04, sortSubInspectionNotes } = useNotesData();
  const clonedComments = clone(structure.structureUnitInspComments) || [];
  sortSubInspectionNotes(clonedComments);

  for (const detail of clonedComments ?? []) {
    InspectionNotes.push(
      [substuctureUnitIN03(detail?.structureUnitId), noteTypeIN04(detail?.commentType), detail?.notes].map((d) => {
        return {
          text: d,
          alignment: "left",
        };
      })
    );
  }
}

export { setNotesDocDefinition };
